export default {
  "description": "お問い合わせ",
}